var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", [
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("h1", { staticClass: "subtitle is-5" }, [
          _vm._v("Autoridad Certificante"),
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "title is-1" }, [
          _vm._v("Oficiales de Registro"),
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("Listado"),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content" }, [
      _c("p", [
        _vm._v('Usuarios de la organización con el rol "Oficial de registro".'),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Puede habilitar o deshabilitar oficiales de registro mediante la acción correspondiente."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }